import { Card, Layout } from 'antd';
import React from 'react';
import Headers from './Header/Headers';
import MenuSideBars from './SideBar/MenuSideBars';

const { Content } = Layout;

function MainLayout({ children }) {
    return (
        <Layout className="app-shell">
            <Headers />
            <Layout className="app-shell__body">
                <MenuSideBars />
                <Layout className="app-shell__main">
                    <Content className="app-content">
                        <Card className="app-content-card" bordered={false}>
                            {children}
                        </Card>
                    </Content>
                </Layout>
            </Layout>
        </Layout>
    );
}

export default MainLayout;
